if (!customElements.get("image-banner")) {
  customElements.define(
    "image-banner",
    class ImageBanner extends HTMLElement {
      constructor() {
        super();
        this.section = this.closest("section");
        this.logoBanner = this;
        this.isMobile = window.matchMedia("(max-width: 899px)").matches;
      }

      connectedCallback() {
        this.setTopMargin();
        this.observeHeader();
      }

      observeHeader() {
        const header = document.querySelector(".wt-header");
        const activeTransparentClass = "wt-header--opacity";
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                header.classList.remove(activeTransparentClass);
              } else {
                header.classList.add(activeTransparentClass);
              }
            });
          },
          { root: null, threshold: 0.05 },
        );

        observer.observe(this.logoBanner);
      }

      isFirstSection() {
        const sectionWrapper = document.querySelector("#root");
        const firstSection = sectionWrapper.querySelector("section");
        const currentSection = this.section;

        return firstSection === currentSection;
      }

      isTransparentHeaderEnabled() {
          const header = document.querySelector(".wt-header");
          return (
            this.isFirstSection() &&
            header.classList.contains("wt-header--v3")
          );
        }

      calculateOffset() {
        const header = document.querySelector("header");
        const headerHeight = header.offsetHeight;
        const wtHeader = document.querySelector('.wt-header')

        const announcment = document.querySelector(".wt-announcement");
        const announcmentHeight = announcment ? announcment.offsetHeight : 0;
        const offset = this.isTransparentHeaderEnabled()
          ? headerHeight + announcmentHeight
          : 0;

        return offset;
      }

      setTopMargin() {
        const offset = this.calculateOffset();
        this.section.style.marginTop = `-${offset}px`;
      }
  },
  );
}
